// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorAlert_container__2sSDv","icon":"ErrorAlert_icon__jdj9h"};